var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import AbstractRepository from "./abstract.repository";
import { LocalDbService } from "../services/database/local-db.service";
import * as i0 from "@angular/core";
import * as i1 from "../services/database/local-db.service";
var ApplicationSettingRepository = /** @class */ (function (_super) {
    __extends(ApplicationSettingRepository, _super);
    function ApplicationSettingRepository(localdb) {
        return _super.call(this, localdb, 'applicationSettings') || this;
    }
    ApplicationSettingRepository.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ApplicationSettingRepository_Factory() { return new ApplicationSettingRepository(i0.ɵɵinject(i1.LocalDbService)); }, token: ApplicationSettingRepository, providedIn: "root" });
    return ApplicationSettingRepository;
}(AbstractRepository));
export { ApplicationSettingRepository };
